// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.th-pantalla-text {
  width: 50vw;
  text-align: center;
  margin: auto;
}
.th-pantalla {
  width: 100vw;
  height: 100vh;
  text-align: center;

  display: flex;
  align-items: center;
}

.th-container-no-stack span {
  padding-left: 2vw;
  padding-right: 2vw;
  margin-right: 4vw;
  margin-left: 2vw;
  text-align: start;
}

/*-----------------------REDESIGN--------------------*/
.th-div-rounded-ha-big {
  height: 35vh;
  background-color: #018bed;
}
.th-div-rounded-ha-small {
  border-radius: 0% 0% 100% 100%;
  margin-top: -2vh;
  height: 7vh;
  background-color: #018bed;
}

.th-img-hello-title {
  margin-top: 15vh;
}
.th-bienvenido {
  color: white;
  font-size: 2.8vh;
}
.th-div-bienvenido {
  margin-left: 3vw;
  margin-right: 3vw;
  margin-top: 5vh;
}
.th-subtitulo-bajo-rounded {
  color: #2b363b;
  margin: 3vh;
  font-size: 2.5vh;
}
.th-div-icon-on-parent {
  height: 20vh;
  width: 100vw;
  text-align: center;
}
.th-div-icon-on {
  height: 20vh;
  margin-top: 8vh;
  background-color: #018bed35;
  width: 90vw;
  margin-left: 5vw;
  bottom: 0%;
  border-radius: 2vw;
  text-align: center;
}

.th-img-hello-pump {
  height: 7vh;
  position: absolute;
  left: 42.5vw;
  margin-bottom: 5vh;
  margin-top: -3.5vh;
}
.th-treintae {
  font-size: 7vh;
  margin-top: 10vh;
}
.th-text-tirada1-container {
  padding-top: 3vh;
}
.th-boton-siguiente-ha2 {
  width: 40vw;
  height: 5vh;
  margin-left: 3vw;
  background-color: white;
  color: #018bed;
  border: 1px solid #018bed;
  text-align: center;
  margin: auto;
  border: solid 2px;
  font-size: 2vh;
  border-radius: 5px;
  line-height: 5.5vh;
}

.th-boton-siguiente-ha3 {
  width: 40vw;
  height: 5vh;
  margin-left: 3vw;
  background-color: white;
  color: #d0d0d1;
  border: 1px solid #d0d0d1;
  text-align: center;
  margin: auto;
  border: solid 2px;
  font-size: 2vh;
  border-radius: 5px;
  line-height: 5vh;
}
.th-boton-siguiente-ha1 {
  width: 40vw;
  height: 5.5vh;
  margin-right: 3vw;
  background-color: #018bed;
  color: white;
  text-align: center;
  font-size: 2vh;
  border-radius: 5px;
  line-height: 5.5vh;
}

.th-row-buttons-ha {
  background-color: white;
  display: flex;
  text-align: center;
}
.th-row-button-ha-parent {
  box-shadow: 0px -1px 5px #cecbcb;
  position: absolute;
  bottom: 0vh;
  background-color: white;
  width: 100vw;
  margin: auto;
  padding-top: 2vh;
  padding-bottom: 0.5vh;
  margin: auto;
  border-radius: 3vw 3vw 0vw 0vw;
  height: 7.5vh;
}

/*---------------------Tirada2-------------*/

.th-texto-containerblue {
  font-size: 2.5vh;
}
.th-img-hello-ruleta {
  position: relative;
  width: 100vw;
  left: 0%;
  height: auto;
}
.th-img-party {
  position: absolute;
  height: 10vh;
  margin-left: 7vw;
  margin-top: 1vh;
}

.th-div-rounded-ha-big2 {
  background-color: #018bed;
  height: -moz-fit-content;
  height: fit-content;
}
.th-text-tirada2-container-row {
  display: flex;
  text-align: center;
}
.th-subtitulo-bajo-gratis {
  font-size: 2.4vh;
}
.th-text2-tirada-ha {
  width: 60vw;
  margin-left: 30vw;
  margin-top: 2vh;
}
.th-div-icon-on-parent2 {
  height: 20vh;
  width: 100vw;
  text-align: center;
}

.th-div-icon-on2 {
  height: 13vh;

  background-color: #018bed35;
  width: 90vw;
  margin-left: 5vw;
  border-radius: 2vw;
  text-align: center;
}
.th-text-gratis {
  font-size: 6vh;
}

/* ---------------tirada3 ----------------*/

.th-img-hello-nestor {
  height: 50vh;
  width: 100vw;
  margin-top: -3vh;
}
.th-icon-box-ha {
  border-radius: 3px;
  display: flex;
  width: 90vw;
  height: 5vh;
  background-color: #018bed;
  margin: auto;
  color: white;
  margin-top: 2vh;
}
.th-icon-box-ha4 {
  border-radius: 3px;
  display: flex;
  position: relative;
  left: 5%;
  top: 5vh;
  width: 90vw;
  height: 5vh;
  background-color: #018bed;
  color: white;
}
.th-icon-box-ha-text {
  text-align: center;
  width: 90vw;
  margin-top: 1.4vh;
}
.th-thinking-icon-ha {
  margin-left: 8vw;
  height: 5vh;
}
.th-box-text-ha {
  padding: 5vw;
  font-size: 2vh;
  margin-top: -2vh;
}
.th-box-text-ha4 {
  padding: 5vw;
  font-size: 2vh;
  margin-top: 2vh;
  line-height: 3vh;
}
.th-div-icon-on3 {
  height: -moz-fit-content;
  height: fit-content;
  margin-top: 2vh;
  padding-bottom: 2vh;
  background-color: #018bed35;
  width: 90vw;
  margin-left: 5vw;
  bottom: 0%;
  border-radius: 2vw;
  text-align: center;
}
.th-parent-ha {
  height: 100vh;
  overflow: auto;
  width: 100vw;
  display: block;
}
.th-parent-ha4 {
  height: 100vh;
  overflow: auto;
  width: 100vw;
  display: block;
}

.th-appbartirada4 {
  z-index: 8;
}

#ha-clipped-container {
  width: 100%;
  position: fixed;
  background-color: #018bed;
  border-radius: 0% 0% 100% 100%;
  z-index: 7;
  /* transform: translate(0%, 0%); */
}
.th-clipped-container-ha {
  margin-top: 11vh;
}

.th-four-buttons {
  margin-top: -6vh;
  z-index: 2;
  position: relative;
}

.th-four-buttons-row {
  display: flex;
  width: 100vw;
  margin-top: 2vh;
  background-color: white;
}

.th-bbox-separation {
  height: 2vh;
}

.th-button-item {
  width: 45vw;
  height: 6vh;
  background-color: #d9eefd;
  margin: auto;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  text-align: center;
  vertical-align: middle;
  line-height: 7vh;
  border-radius: 5px;
}

.th-button-item.th-button-item-focus {
  background-color: white;
  color: #018bed;
  border: 2px solid #018bed;
  border-radius: 5px;
}

.th-reborde {
  height: 4vh;
  width: 2vw;
  background-color: #018bed;
  border-radius: 0% 100% 100% 0%;
  float: left;
  margin-top: 1vh;
}

.th-button-item-text {
  text-align: center;
  margin-right: 3vw;
}

.th-horizontal-scroll-ha {
  margin-top: -1vh;
  height: 22vh;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.th-item-horizontal-scroll-ha {
  border-radius: 12px;
  background-color: #d9eefd;
  border-radius: 5px;
  width: 30vw;
  height: 22vh;
  margin-left: 2vw;
  display: inline-block;
  padding-right: 2vw;
}

.th-icon-item-horizontal-scroll-ha {
  position: relative;
  width: 6vw;
  height: 6vw;
  margin-top: 2vh;
  margin-right: 20vw;
}

.th-text-item-horizontal-scroll-ha {
  left: 2vw;
  width: 30vw;
  margin-left: 2vw;
  padding-right: 2vw;
  justify-content: start;
  text-align: start;
  font-size: 1.7vh;
  white-space: normal;
}

/*------------tirada 5 -----------*/
.th-icon-box-ha5 {
  border-radius: 3px;
  display: flex;
  position: absolute;
  left: 5%;
  top: 15vh;
  width: 90vw;
  text-align: start;
  height: 7vh;
  background-color: #018bed;
  color: white;
}

.th-icon-ha5 {
  margin-left: 5vw;
  height: 6vh;
  margin-top: 0.5vh;
}

.th-box-text-ha5 {
  padding: 5vw;
  font-size: 2.3vh;
  margin-top: 24vh;
  text-align: start;
}

.th-icon-box-ha-text5 {
  margin: 3vw;
}

.th-div-icon-on-parent5 {
  height: 17vh;
  width: 100vw;
  text-align: center;
}

.th-div-icon-on5 {
  height: 17vh;
  margin-top: 8vh;
  background-color: #018bed35;
  width: 90vw;
  margin-left: 5vw;
  bottom: 0%;
  border-radius: 2vw;
  text-align: center;
}

.th-text-tirada5-container {
  padding-top: 4.5vh;
}

@media screen and (min-width: 768px) {
  .th-icon-box-ha4 {
    position: sticky;
    margin-bottom: 2vh;
  }
  .th-icon-box-ha-text {
    font-size: 3vw;
  }
}
.th-embed {
  height: 88vh;
  width: 100vw;
  margin-top: 12vh;
}
`, "",{"version":3,"sources":["webpack://./src/tirada-con-hello/tirada.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;AAEA,4CAA4C;;AAE5C;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;;EAEZ,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA,2CAA2C;;AAE3C;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".th-pantalla-text {\n  width: 50vw;\n  text-align: center;\n  margin: auto;\n}\n.th-pantalla {\n  width: 100vw;\n  height: 100vh;\n  text-align: center;\n\n  display: flex;\n  align-items: center;\n}\n\n.th-container-no-stack span {\n  padding-left: 2vw;\n  padding-right: 2vw;\n  margin-right: 4vw;\n  margin-left: 2vw;\n  text-align: start;\n}\n\n/*-----------------------REDESIGN--------------------*/\n.th-div-rounded-ha-big {\n  height: 35vh;\n  background-color: #018bed;\n}\n.th-div-rounded-ha-small {\n  border-radius: 0% 0% 100% 100%;\n  margin-top: -2vh;\n  height: 7vh;\n  background-color: #018bed;\n}\n\n.th-img-hello-title {\n  margin-top: 15vh;\n}\n.th-bienvenido {\n  color: white;\n  font-size: 2.8vh;\n}\n.th-div-bienvenido {\n  margin-left: 3vw;\n  margin-right: 3vw;\n  margin-top: 5vh;\n}\n.th-subtitulo-bajo-rounded {\n  color: #2b363b;\n  margin: 3vh;\n  font-size: 2.5vh;\n}\n.th-div-icon-on-parent {\n  height: 20vh;\n  width: 100vw;\n  text-align: center;\n}\n.th-div-icon-on {\n  height: 20vh;\n  margin-top: 8vh;\n  background-color: #018bed35;\n  width: 90vw;\n  margin-left: 5vw;\n  bottom: 0%;\n  border-radius: 2vw;\n  text-align: center;\n}\n\n.th-img-hello-pump {\n  height: 7vh;\n  position: absolute;\n  left: 42.5vw;\n  margin-bottom: 5vh;\n  margin-top: -3.5vh;\n}\n.th-treintae {\n  font-size: 7vh;\n  margin-top: 10vh;\n}\n.th-text-tirada1-container {\n  padding-top: 3vh;\n}\n.th-boton-siguiente-ha2 {\n  width: 40vw;\n  height: 5vh;\n  margin-left: 3vw;\n  background-color: white;\n  color: #018bed;\n  border: 1px solid #018bed;\n  text-align: center;\n  margin: auto;\n  border: solid 2px;\n  font-size: 2vh;\n  border-radius: 5px;\n  line-height: 5.5vh;\n}\n\n.th-boton-siguiente-ha3 {\n  width: 40vw;\n  height: 5vh;\n  margin-left: 3vw;\n  background-color: white;\n  color: #d0d0d1;\n  border: 1px solid #d0d0d1;\n  text-align: center;\n  margin: auto;\n  border: solid 2px;\n  font-size: 2vh;\n  border-radius: 5px;\n  line-height: 5vh;\n}\n.th-boton-siguiente-ha1 {\n  width: 40vw;\n  height: 5.5vh;\n  margin-right: 3vw;\n  background-color: #018bed;\n  color: white;\n  text-align: center;\n  font-size: 2vh;\n  border-radius: 5px;\n  line-height: 5.5vh;\n}\n\n.th-row-buttons-ha {\n  background-color: white;\n  display: flex;\n  text-align: center;\n}\n.th-row-button-ha-parent {\n  box-shadow: 0px -1px 5px #cecbcb;\n  position: absolute;\n  bottom: 0vh;\n  background-color: white;\n  width: 100vw;\n  margin: auto;\n  padding-top: 2vh;\n  padding-bottom: 0.5vh;\n  margin: auto;\n  border-radius: 3vw 3vw 0vw 0vw;\n  height: 7.5vh;\n}\n\n/*---------------------Tirada2-------------*/\n\n.th-texto-containerblue {\n  font-size: 2.5vh;\n}\n.th-img-hello-ruleta {\n  position: relative;\n  width: 100vw;\n  left: 0%;\n  height: auto;\n}\n.th-img-party {\n  position: absolute;\n  height: 10vh;\n  margin-left: 7vw;\n  margin-top: 1vh;\n}\n\n.th-div-rounded-ha-big2 {\n  background-color: #018bed;\n  height: fit-content;\n}\n.th-text-tirada2-container-row {\n  display: flex;\n  text-align: center;\n}\n.th-subtitulo-bajo-gratis {\n  font-size: 2.4vh;\n}\n.th-text2-tirada-ha {\n  width: 60vw;\n  margin-left: 30vw;\n  margin-top: 2vh;\n}\n.th-div-icon-on-parent2 {\n  height: 20vh;\n  width: 100vw;\n  text-align: center;\n}\n\n.th-div-icon-on2 {\n  height: 13vh;\n\n  background-color: #018bed35;\n  width: 90vw;\n  margin-left: 5vw;\n  border-radius: 2vw;\n  text-align: center;\n}\n.th-text-gratis {\n  font-size: 6vh;\n}\n\n/* ---------------tirada3 ----------------*/\n\n.th-img-hello-nestor {\n  height: 50vh;\n  width: 100vw;\n  margin-top: -3vh;\n}\n.th-icon-box-ha {\n  border-radius: 3px;\n  display: flex;\n  width: 90vw;\n  height: 5vh;\n  background-color: #018bed;\n  margin: auto;\n  color: white;\n  margin-top: 2vh;\n}\n.th-icon-box-ha4 {\n  border-radius: 3px;\n  display: flex;\n  position: relative;\n  left: 5%;\n  top: 5vh;\n  width: 90vw;\n  height: 5vh;\n  background-color: #018bed;\n  color: white;\n}\n.th-icon-box-ha-text {\n  text-align: center;\n  width: 90vw;\n  margin-top: 1.4vh;\n}\n.th-thinking-icon-ha {\n  margin-left: 8vw;\n  height: 5vh;\n}\n.th-box-text-ha {\n  padding: 5vw;\n  font-size: 2vh;\n  margin-top: -2vh;\n}\n.th-box-text-ha4 {\n  padding: 5vw;\n  font-size: 2vh;\n  margin-top: 2vh;\n  line-height: 3vh;\n}\n.th-div-icon-on3 {\n  height: fit-content;\n  margin-top: 2vh;\n  padding-bottom: 2vh;\n  background-color: #018bed35;\n  width: 90vw;\n  margin-left: 5vw;\n  bottom: 0%;\n  border-radius: 2vw;\n  text-align: center;\n}\n.th-parent-ha {\n  height: 100vh;\n  overflow: auto;\n  width: 100vw;\n  display: block;\n}\n.th-parent-ha4 {\n  height: 100vh;\n  overflow: auto;\n  width: 100vw;\n  display: block;\n}\n\n.th-appbartirada4 {\n  z-index: 8;\n}\n\n#ha-clipped-container {\n  width: 100%;\n  position: fixed;\n  background-color: #018bed;\n  border-radius: 0% 0% 100% 100%;\n  z-index: 7;\n  /* transform: translate(0%, 0%); */\n}\n.th-clipped-container-ha {\n  margin-top: 11vh;\n}\n\n.th-four-buttons {\n  margin-top: -6vh;\n  z-index: 2;\n  position: relative;\n}\n\n.th-four-buttons-row {\n  display: flex;\n  width: 100vw;\n  margin-top: 2vh;\n  background-color: white;\n}\n\n.th-bbox-separation {\n  height: 2vh;\n}\n\n.th-button-item {\n  width: 45vw;\n  height: 6vh;\n  background-color: #d9eefd;\n  margin: auto;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  text-align: center;\n  vertical-align: middle;\n  line-height: 7vh;\n  border-radius: 5px;\n}\n\n.th-button-item.th-button-item-focus {\n  background-color: white;\n  color: #018bed;\n  border: 2px solid #018bed;\n  border-radius: 5px;\n}\n\n.th-reborde {\n  height: 4vh;\n  width: 2vw;\n  background-color: #018bed;\n  border-radius: 0% 100% 100% 0%;\n  float: left;\n  margin-top: 1vh;\n}\n\n.th-button-item-text {\n  text-align: center;\n  margin-right: 3vw;\n}\n\n.th-horizontal-scroll-ha {\n  margin-top: -1vh;\n  height: 22vh;\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n.th-item-horizontal-scroll-ha {\n  border-radius: 12px;\n  background-color: #d9eefd;\n  border-radius: 5px;\n  width: 30vw;\n  height: 22vh;\n  margin-left: 2vw;\n  display: inline-block;\n  padding-right: 2vw;\n}\n\n.th-icon-item-horizontal-scroll-ha {\n  position: relative;\n  width: 6vw;\n  height: 6vw;\n  margin-top: 2vh;\n  margin-right: 20vw;\n}\n\n.th-text-item-horizontal-scroll-ha {\n  left: 2vw;\n  width: 30vw;\n  margin-left: 2vw;\n  padding-right: 2vw;\n  justify-content: start;\n  text-align: start;\n  font-size: 1.7vh;\n  white-space: normal;\n}\n\n/*------------tirada 5 -----------*/\n.th-icon-box-ha5 {\n  border-radius: 3px;\n  display: flex;\n  position: absolute;\n  left: 5%;\n  top: 15vh;\n  width: 90vw;\n  text-align: start;\n  height: 7vh;\n  background-color: #018bed;\n  color: white;\n}\n\n.th-icon-ha5 {\n  margin-left: 5vw;\n  height: 6vh;\n  margin-top: 0.5vh;\n}\n\n.th-box-text-ha5 {\n  padding: 5vw;\n  font-size: 2.3vh;\n  margin-top: 24vh;\n  text-align: start;\n}\n\n.th-icon-box-ha-text5 {\n  margin: 3vw;\n}\n\n.th-div-icon-on-parent5 {\n  height: 17vh;\n  width: 100vw;\n  text-align: center;\n}\n\n.th-div-icon-on5 {\n  height: 17vh;\n  margin-top: 8vh;\n  background-color: #018bed35;\n  width: 90vw;\n  margin-left: 5vw;\n  bottom: 0%;\n  border-radius: 2vw;\n  text-align: center;\n}\n\n.th-text-tirada5-container {\n  padding-top: 4.5vh;\n}\n\n@media screen and (min-width: 768px) {\n  .th-icon-box-ha4 {\n    position: sticky;\n    margin-bottom: 2vh;\n  }\n  .th-icon-box-ha-text {\n    font-size: 3vw;\n  }\n}\n.th-embed {\n  height: 88vh;\n  width: 100vw;\n  margin-top: 12vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
